import React from "react";

interface TopEntryControlProps {
  projectId: number;
  rank?: number;
  count?: number;
  showCount: boolean;
  canSelect: boolean;
  max?: number;
  variant?: "icon" | "ranks";
  onClick: (projectId: number) => void;
  onPickRank?: (projectId: number, rank: number) => void;
}

export default function TopEntryControl(props: TopEntryControlProps) {
  if (!props.canSelect && !props.showCount) return null;

  const handleToggle = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (props.canSelect) props.onClick(props.projectId);
  };

  const handleRank = (e: React.MouseEvent, n: number) => {
    e.stopPropagation();
    if (!props.canSelect) return;
    if (props.rank === n) props.onClick(props.projectId);
    else if (props.onPickRank) props.onPickRank(props.projectId, n);
    else props.onClick(props.projectId);
  };

  if (props.variant === "ranks" && props.canSelect) {
    const max = props.max && props.max > 0 ? props.max : 3;
    return (
      <div className="top-entry-ranks">
        <span className="top-entry-ranks-label">My top pick</span>
        {Array.from({ length: max }, (_, i) => i + 1).map((n) => (
          <button
            key={n}
            type="button"
            className={`btn btn-xs ${
              props.rank === n ? "btn-warning" : "btn-default"
            } top-entry-rank-btn`}
            title={
              props.rank === n
                ? `Remove as #${n} top entry`
                : `Mark as #${n} top entry`
            }
            onClick={(e) => handleRank(e, n)}
          >
            <i className={`${props.rank === n ? "fad" : "fal"} fa-star`}></i>
            &nbsp;#{n}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      className={`top-entry-container${props.canSelect ? " click" : ""}`}
      title={
        props.rank
          ? `Your #${props.rank} entry — click to remove`
          : props.canSelect
          ? "Mark as a top pick"
          : "Top entry"
      }
      onClick={handleToggle}
    >
      {props.showCount && (props.count || 0) > 0 && <>{props.count}</>}
      {props.rank ? (
        <span className="top-entry-rank">
          <i className="fad fa-star top-entry-star"></i>
          <span className="top-entry-rank-num">{props.rank}</span>
        </span>
      ) : (
        <i className="fal fa-star top-entry-star"></i>
      )}
    </div>
  );
}
